import { apiConfig } from '../../services/apiConfig';

const TOKEN_ID = (localStorage && localStorage.getItem('id_token')) || '';

export const TM_CONSTANTS = {
  TM_BASE_URL: `${apiConfig.serviceApi}`,
  HTTP_HEADERS: Object.freeze({
    'Content-Type': 'application/json',
    'X-HTTP-Method-Override': 'PUT',
    // Authorization: `${TOKEN_ID}`
    Authorization: `Bearer ${TOKEN_ID}`
  }),
  GET_SUCCESS_DATA: 'getSuccessData',
  GET_FAILURE_DATA: 'getFailData',
  GET_DATA: 'getData'
};

export const TM_TAB_LIST = ['Alert Listing', 'Alert Details'];
export const TM_TAB_PAGEID_LIST = ['TM_ALERT_LISTING', 'TM_ALERT_DETAILS'];
